import { ModelInstance, BaseModel, ToFrontHook, ToBackHook, listField } from './util';
import { Team } from './team';
import { TournamentGroup } from './tournament-group';
import { Game } from './game';
import { Tournament } from './tournament';
import { File } from './file';
import { TournamentDivision } from './tournament-division';
import { TournamentTeamFieldValue } from './tournament-team-field-value';

@ModelInstance({
  mappingFields: {
    nickname: 'nickname',
    color: 'color',
  }
})
export class TeamAdditionalData {
  nickname: string;
  color: string;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}

@ModelInstance({
  mappingFields: {
    id: 'id',
    name: 'name',
    logo: 'logo',
    team_photo: 'teamPhoto',
    team_uniform: 'teamUniform',
    team_id: 'teamId',
    tournament_id: 'tournamentId',
    tournament: 'tournament',
    team: 'team',
    group: 'group',
    division: 'division',
    final_standing: 'finalStanding',
    games_count: 'gamesCount',
    won_games_count: 'wonGamesCount',
    draw_games_count: 'drawGamesCount',
    lose_games_count: 'loseGamesCount',
    last_games_count: 'lastGamesCount',
    last_games_won: 'lastGamesWon',
    score_sum: 'scoreSum',
    missed_sum: 'missedSum',
    score_points_sum: 'scorePointsSum',
    missed_points_sum: 'missedPointsSum',
    best_score_diff: 'bestScoreDiff',
    best_score_points_diff: 'bestScorePointsDiff',
    buchholz_score: 'buchholzScore',
    points: 'points',
    mt_points: 'mtPoints',
    users_count: 'usersCount',
    games: 'games',
    notifications_count: 'notificationsCount',
    win_normal_time_games_count: 'winNormalTimeGamesCount',
    lose_normal_time_games_count: 'loseNormalTimeGamesCount',
    win_overtime_games_count: 'winOvertimeGamesCount',
    lose_overtime_games_count: 'loseOvertimeGamesCount',
    last_five_games: 'lastFiveGames',
    tries_scored: 'triesScored',
    tries_missed: 'triesMissed',
    attack_bonuses: 'attackBonuses',
    defense_bonuses: 'defenseBonuses',
    team_additional_data: 'teamAdditionalData',
    field_values: 'fieldValues',
  },
  relation: {
    logo: File,
    teamPhoto: File,
    teamUniform: File,
    tournament: Tournament,
    team: Team,
    group: TournamentGroup,
    games: Game,
    lastFiveGames: Game,
    division: TournamentDivision,
    teamAdditionalData: TeamAdditionalData,
    fieldValues: listField(TournamentTeamFieldValue),
  }
})
export class TournamentTeam extends BaseModel {
  id: number;
  name: string;
  logo: File;
  teamPhoto: File;
  teamUniform: File;
  teamId: number;
  tournamentId: number;
  tournament: Tournament;
  team: Team;
  group: TournamentGroup;
  division: TournamentDivision;
  teamAdditionalData: TeamAdditionalData;
  finalStanding: number;
  gamesCount: number;
  wonGamesCount: number;
  loseGamesCount: number;
  drawGamesCount: number;
  lastGamesCount: number;
  lastGamesWon: number;
  scoreSum: number;
  missedSum: number;
  scorePointsSum: number;
  missedPointsSum: number;
  bestScoreDiff: number;
  bestScorePointsDiff: number;
  buchholzScore: number;
  points: number;
  mtPoints: number;
  usersCount: number;
  games: Game[];
  notificationsCount: number;
  winNormalTimeGamesCount: number;
  loseNormalTimeGamesCount: number;
  winOvertimeGamesCount: number;
  loseOvertimeGamesCount: number;
  lastFiveGames: Game[];
  triesScored: number;
  triesMissed: number;
  attackBonuses: number;
  defenseBonuses: number;
  fieldValues: TournamentTeamFieldValue[];

  get gamesWonPercent(): number {
    if (!this.gamesCount) {
      return 0;
    }
    return Math.floor(1000 * this.wonGamesCount / this.gamesCount) / 10;
  }

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
